import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista"
import Popup from "../../components/Popup";
import servAnalises from "../../services/login/servAnalises";
import { columnsAnaliseSolicitacaoAcesso } from "./Lista";
import styles from "./SolicitacaoAcessoAnalise.module.css";
import Cadastro from "../SolicitacaoAcesso/Cadastro";

const SolicitacaoAAnalise = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [openAnalise, setOpenAnalise] = useState(false);
    const [recordForView, setRecordForView] = useState(null);
    const [analisesSolicitacao, setAnalisesSolicitacao] = useState([]);
    const [tabResultadoAnalise, setTabResultadoAnalise] = useState(false);
    const [eNovoCadastro, setENovoCadastro] = useState(false);
    const [analisesDaSolic, SetAnalisesDaSolic] = useState(false);

    const analises = useSelector((state) => state.analises);

    const onClickPesquisar = async () => {
        try {

            setIsLoading(true);

            const data = await servAnalises.ListarSolicitacoesDeAcesso(analises.codigoSolicitacaoDeAcesso, filtro);
            
            let analiseSolic = data.Content;

            analiseSolic.map((analise) => {
                analise.id = analise.Id
            });

            setAnalisesSolicitacao(analiseSolic);

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);

            console.log(err.Messsage);
        }
    }

    useEffect(() => {

        const recuperarAnalisesAnteriores = async () => {
            try {

                setIsLoading(true);

                const data = await servAnalises.ListarSolicitacoesDeAcesso(analises.codigoSolicitacaoDeAcesso, "");

                let analiseSolic = data.Content;

                analiseSolic.map((analise) => {
                    analise.id = analise.Id;
                })

                setAnalisesSolicitacao(analiseSolic);
                setTabResultadoAnalise(true);
                setENovoCadastro(false);
                SetAnalisesDaSolic(true);

                setIsLoading(false);
                
            } catch (err) {
                
                setIsLoading(false);

            }
        }

        if (analises.codigoSolicitacaoDeAcesso) {
            recuperarAnalisesAnteriores();
        } 

    }, [analises]);

    return (
        <div className={styles.solicitacaoContainer}>
            <h2 style={{ margin: 0}}>Análises do orçamento de conexão</h2>
            <div className={styles.solicitacaoFiltros}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8" }}>Data de apresentação</InputLabel>
                    <WhiteInput 
                        value={filtro} 
                        onChange={(e) => setFiltro(e.target.value)} 
                        type="date"
                        id="pesquisa-data" 
                        sx={{ width: "500px", marginRight: "10px" }}     
                    />
                </FormControl>
                <BlueHoverButton onClick={onClickPesquisar} variant="contained"  style={{ marginTop: "15px" }} >
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div>
                <Lista
                    columns={columnsAnaliseSolicitacaoAcesso}
                    rows={analisesSolicitacao}
                    onDblClick={setOpenAnalise}
                    setSelectedData={setRecordForView}
                    hideFooter={true}
                    autoHeight={true}

                />
            </div>
            <Popup title="Análise do orçamento de conexão" openPopup={openAnalise} setOpenPopup={setOpenAnalise}>
                <Cadastro
                    setOpen={setOpenAnalise}
                    recordForEdit={analisesSolicitacao}
                    pesquisar={onClickPesquisar}
                    novoCadastro={eNovoCadastro}
                    setEhNovoCadastro={setENovoCadastro}
                    tabResultadoAnalise={tabResultadoAnalise}
                    analisesDaSolic={analisesDaSolic}
                    recordForView={recordForView}
                    key={"SolicitacaoAcesso"}
                />
            </Popup>
        </div>
    )
}

export { SolicitacaoAAnalise }